module.exports = __webpack_public_path__ + "media/application/images/svgs/blob-5-328a58ddbe759abdc867f2580318c62c.svg";